const determineManualOrder = () => {
  if (typeof window !== "undefined") {
    return (
      window.manualOrderToken &&
      window.isManualOrder &&
      window.manualOrderSettings
    );
  }
  return false;
};

const fetchManualOrderSettings = () => {
  if (
    typeof window !== "undefined" &&
    window.manualOrderToken &&
    window.isManualOrder &&
    window.manualOrderSettings
  ) {
    let cleanedSetting = window.manualOrderSettings.replace(/\\"/g, '"');
    cleanedSetting = cleanedSetting.substring(1, cleanedSetting.length - 1);
    return JSON.parse(cleanedSetting);
  }
  return false;
};

export { determineManualOrder, fetchManualOrderSettings };
